import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import useAuth from 'common/hooks/useAuth';

import { useSetupSentryQuery } from 'common/apollo/graphql';

import 'common/sentry';

function SetupSentry(): null {
  const { isAuthenticated } = useAuth();
  const { data: { me } = {} } = useSetupSentryQuery({
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (me) {
      Sentry.setUser({
        id: me?.id!,
        email: me?.email!,
      });
    }
  }, [me]);

  return null;
}

export default SetupSentry;
